<div mat-dialog-title class="dialog-title">
  <h2>{{ 'profileStrangers.titleOrganization' | transloco }}</h2>
  <button class="close-btn" (click)="closeDialog()"></button>
</div>

<mat-dialog-content>
  <form [formGroup]="form" class="form">
    <mat-form-field appearance="fill" class="col-12 col-md-6 col-lg-4">
      <mat-label>{{ 'registrationStrangers.country' | transloco }} *</mat-label>
      <mat-select formControlName="country" data-test="profileStrangers_select-country" (openedChange)="onSelectOpened($event)">
        <mat-option [disabled]="true" style="position: sticky; top: 0; background: white; z-index: 1;">
          <input
            matInput
            [(ngModel)]="searchQuery"
            (ngModelChange)="filterCountries()"
            (click)="$event.stopPropagation()"
            placeholder="{{ 'registrationStrangers.search' | transloco }}"
            [ngModelOptions]="{standalone: true}">
        </mat-option>
        <mat-option *ngFor="let country of filteredCountries" [value]="country.code">
          {{ getActiveLang === 'ru' ? country.name : country.inEnglish }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('country')?.hasError('required')">
        {{ getErrorMessage('country') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-12 col-md-6 col-lg-4">
      <mat-label>{{ 'registrationStrangers.code' | transloco }} *</mat-label>
      <input matInput
             name="inn"
             formControlName="inn"
             type="text"
             data-test="profileStrangers_input-inn">
      <mat-error *ngIf="form.get('inn')?.hasError('required')">
        {{ getErrorMessage('inn') }}
      </mat-error>
      <mat-error *ngIf="form.get('inn')?.hasError('pattern')">
        {{ getErrorMessage('inn') }}
      </mat-error>
      <mat-error *ngIf="form.get('inn')?.hasError('minlength') || form.get('inn')?.hasError('maxlength')">
        {{ getErrorMessage('inn') }}
      </mat-error>
    </mat-form-field>

    <app-notification #notification
                      class="w-100"
                      [hidden]="!notification?.isShow">
    </app-notification>

    <mat-form-field *ngIf="isExtendedFieldsShow" appearance="fill" class="col-12 col-md-6 col-lg-3">
      <mat-label>{{ 'registrationStrangers.orgForm' | transloco }} *</mat-label>
      <input matInput
             formControlName="legalForm"
             data-test="profileStrangers_input-legalForm">
      <mat-error *ngIf="form.get('legalForm')?.hasError('required')">
        {{ getErrorMessage('legalForm') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="isExtendedFieldsShow" appearance="fill" class="col-12 col-md-6 col-lg-4">
      <mat-label>{{ 'profileStrangers.orgShortName' | transloco }}</mat-label>
      <input matInput
             formControlName="shortName"
             data-test="profileStrangers_input-shortName">
      <mat-error *ngIf="form.get('shortName')?.hasError('pattern')">
        {{ getErrorMessage('shortName') }}
      </mat-error>
      <mat-error *ngIf="form.get('shortName')?.hasError('minlength') || form.get('shortName')?.hasError('maxlength')">
        {{ getErrorMessage('shortName') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="isExtendedFieldsShow" appearance="fill" class="col-12 col-md-6 col-lg-8">
      <mat-label>{{ 'profileStrangers.orgName' | transloco }} *</mat-label>
      <input matInput
             formControlName="fullName"
             data-test="profileStrangers_input-fullName">
      <mat-error *ngIf="form.get('fullName')?.hasError('required')">
        {{ getErrorMessage('fullName') }}
      </mat-error>
      <mat-error *ngIf="form.get('fullName')?.hasError('pattern')">
        {{ getErrorMessage('fullName') }}
      </mat-error>
      <mat-error *ngIf="form.get('fullName')?.hasError('minlength') || form.get('fullName')?.hasError('maxlength')">
        {{ getErrorMessage('fullName') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="isExtendedFieldsShow" appearance="fill" class="col-12 col-md-6 col-lg-4">
      <mat-label>{{ 'profileStrangers.email' | transloco }} *</mat-label>
      <input matInput
             formControlName="email"
             type="email"
             data-test="profileStrangers_input-email">
      <mat-error *ngIf="form.get('email')?.hasError('required')">
        {{ getErrorMessage('email') }}
      </mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('pattern')">
        {{ getErrorMessage('email') }}
      </mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('minlength') || form.get('email')?.hasError('maxlength')">
        {{ getErrorMessage('email') }}
      </mat-error>
    </mat-form-field>

    <app-phone-custom *ngIf="isExtendedFieldsShow"
                      [formControl]="phoneControl"
                      [allCountries]="data.phoneCountries"
                      (phoneChange)="onPhoneChange($event)"
                      [required]="isExtendedFieldsShow"
                      placeholder="{{ 'profileStrangers.phoneNumber' | transloco }}"
                      placeholderSearch="{{ 'registrationStrangers.search' | transloco }}"
                      errorRequired="{{ 'errorCodes.FIELD_REQUIRED' | transloco }}"
                      data-test="profileStrangers_input-phone"
                      [disabled]="isLoading"
                      class="phone col-12 col-md-6 col-lg-4">
    </app-phone-custom>
    <mat-error *ngIf="form.get('phone')?.hasError('required') && form.get('phone')?.touched">
      {{ getErrorMessage('phone') }}
    </mat-error>
    <mat-error *ngIf="form.get('phone')?.hasError('pattern') && form.get('phone')?.touched">
      {{ getErrorMessage('phone') }}
    </mat-error>
    <mat-error *ngIf="form.get('phone')?.hasError('minlength') && form.get('phone')?.touched">
      {{ getErrorMessage('phone') }}
    </mat-error>
    <mat-error *ngIf="form.get('phone')?.hasError('maxlength') && form.get('phone')?.touched">
      {{ getErrorMessage('phone') }}
    </mat-error>

    <mat-form-field *ngIf="isExtendedFieldsShow"
     appearance="fill" class="col-12 col-md-6 col-lg-8">
      <mat-label>{{ 'profileStrangers.addressTitle2' | transloco }} *</mat-label>
      <input matInput
             formControlName="address"
             data-test="profileStrangers_input-address">
      <mat-error *ngIf="form.get('address')?.hasError('required')">
        {{ getErrorMessage('address') }}
      </mat-error>
      <mat-error *ngIf="form.get('address')?.hasError('pattern')">
        {{ getErrorMessage('address') }}
      </mat-error>
      <mat-error *ngIf="form.get('address')?.hasError('minlength') || form.get('address')?.hasError('maxlength')">
        {{ getErrorMessage('address') }}
      </mat-error>
    </mat-form-field>
  </form>
  <mat-error *ngIf="registerError" class="error">{{ registerError }}</mat-error>
</mat-dialog-content>

<mat-dialog-actions>
  <button *ngIf="!isLoading" class="secondary xl me-2" mat-stroked-button disableRipple mat-dialog-close>
    {{ 'cancel' | transloco }}
  </button>
  <button *ngIf="isCheckButtonAvailable"
          class="primary xl me-2"
          mat-raised-button
          disableRipple
          [disabled]="!isRegistrationButtonVisible()"
          (click)="onCheckOrganizationClick()">
    {{ 'profileStrangers.check' | transloco }}
  </button>
  <button *ngIf="isRegistationButtonAvailable"
          class="primary xl"
          mat-raised-button
          disableRipple
          [disabled]="!isRegistrationFormValid()"
          (click)="onJoinToOrganizationClick()">
    {{ 'registration.registration' | transloco }}
  </button>
  <div *ngIf="isLoading" class="spinner">
    <mat-spinner [diameter]="40" class="m-auto"></mat-spinner>
  </div>
</mat-dialog-actions>
